export default __webpack_public_path__ + "static/media/pay respects 10.a139bf25.png";